import { get } from 'lodash-es';
import createCachedSelector from 're-reselect';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { GridConfigService } from '../../../services/grid-config-service';
import { baseColumnsDefaultConfigs, defaultColumnConfigurations } from '../../../store/customers/grid/default-column-configuration';

export const selectCustomers = (state) => get(state, 'customers', emptyArray);
export const selectCustomerById = (state, props) => {
  const customers = selectCustomers(state);
  return customers.find((customer) => customer.customerId === props.customerId);
};
export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectPage = (state) => get(state, 'page');
export const selectPageSize = (state) => get(state, 'pageSize');

export const selectTotalRecords = (state) => get(state, 'totalRecords');
export const selectTotalPages = (state) => get(state, 'totalPages');
export const selectViewStartingCount = (state) => get(state, 'viewStartingCount');
export const selectViewEndingCount = (state) => get(state, 'viewEndingCount');
export const selectUserGridConfigurations = (state) => get(state, 'userViewConfigurations', emptyObject);
export const selectSearchTerm = (state) => get(state, 'searchTerm');

const selectCustomViewColumnConfiguration = (state) => get(state, 'customViewColumnConfiguration');
const mergeConfigurationsSelector = createCachedSelector(
  (viewConfiguration) => viewConfiguration,
  (viewConfiguration) => GridConfigService.mergeUserAndDefaultConfigs(viewConfiguration, defaultColumnConfigurations),
)((_, statusViewId, activeFilterViewId) => `${statusViewId}_${activeFilterViewId}`);

export const selectCurrentViewGridConfigOrDefault = (state, { activeFilterViewId, statusViewId }) => {
  if (activeFilterViewId === 'custom') {
    const viewConfiguration = selectCustomViewColumnConfiguration(state);
    return mergeConfigurationsSelector(viewConfiguration, statusViewId, activeFilterViewId);
  }

  const allGridConfigs = selectUserGridConfigurations(state);
  const { [activeFilterViewId]: configForView } = allGridConfigs[statusViewId] || {};

  if (!configForView) {
    return baseColumnsDefaultConfigs;
  }

  return mergeConfigurationsSelector(configForView, statusViewId, activeFilterViewId);
};

export const selectCurrentOrderByColumn = (state, { statusViewId, activeFilterViewId }) => {
  const gridConfig =
    selectCurrentViewGridConfigOrDefault(state, {
      statusViewId,
      activeFilterViewId,
    }) || emptyArray;

  return gridConfig.find((col) => !!col.sorted);
};
